<template>
  <nav>
    <div><img src="../assets/MN logo 40px-40px.png" alt="Logo"></div> 
    <div class="cl-matchreportslogo"><h3>Match Reports</h3></div>
    <div class="cl-userinfo">
      <div>
        <span>{{ currentUserOrg }}</span> &#40;
        <span>{{ currentUserRole }}</span>&#32;&#41;
        <span>{{ currentUserNameFirst }} {{ currentUserNameLast }}</span>
      </div>
    </div>
    <div>
      <ul class="cl-weblinks">
        <li><router-link to="/dashboard-admin">Referee Reports</router-link></li>
        <li><router-link to="/misconduct-admin">Misconduct</router-link></li>
        <li><router-link to="/maintain-useraccount">Account</router-link></li>
        <li><router-link to="/maintain-leagues">Leagues</router-link></li>
        <li><router-link to="/maintain-gameschedule">Game Schedule</router-link></li>
        <li><router-link to="/maintain-misconductcodes">MisconductCodes</router-link></li>
        <li><router-link to="/maintain-users">Users</router-link></li>        
        <li><router-link to="/metrics">Metrics</router-link></li>        
        <li><router-link to="/help">Help</router-link></li>
        <button @click="processLogout" class="cl-logoutbutton">Logout</button>
      </ul>
    </div>
  </nav>
</template>

<script>
import { signOut } from "firebase/auth";
import { auth, db } from "../firebase.js";
import { ref, defineComponent, onMounted } from "vue";
import { doc, getDoc, collection, getDocs } from 'firebase/firestore';

export default defineComponent({
  name: 'NavbarSMRmaster',
  setup() {
    const currentUserNameFirst = ref(null)
    const currentUserNameLast = ref(null)
    const currentUserOrg = ref(null)
    const currentUserRole = ref(null);
    const errorMessage = ref(null); // for error handling

    // Fetch user's role after they have logged in
    onMounted(async () => {
      try {
        const user = auth.currentUser;
        if (user) {
          const userDocRef = doc(db, 'users', user.uid);
          const userDocSnap = await getDoc(userDocRef);

          if (userDocSnap.exists()) {
            const userData = userDocSnap.data();
            currentUserNameFirst.value = userData.NameFirst;
            currentUserNameLast.value = userData.NameLast;

            // Query the user's 'organizations' subcollection
            const orgSubColRef = collection(userDocRef, 'Organizations');
            const orgQuerySnapshot = await getDocs(orgSubColRef);

            // Check if the user has any organizations and get the first one (or adjust this logic if needed)
            if (!orgQuerySnapshot.empty) {
              const orgDoc = orgQuerySnapshot.docs[0].data();  // Get first organization
              currentUserOrg.value = orgDoc.OrgName;
              currentUserRole.value = orgDoc.Role;
            } else {
              errorMessage.value = "No organizations found for this user.";
            }
          } else {
            errorMessage.value = "User data not found!";
          }
        } else {
          errorMessage.value = "No user logged in!";
        }
      } catch (error) {
        console.error(error);
        errorMessage.value = "Error fetching user data.";
      }
    });

    const processLogout = async () => {
      try {
        await signOut(auth);
        console.log("User signed out");
        window.location.href = "/"; // Redirect to the login page
      } catch (error) {
        console.error("Error signing out: ", error);
      }
    };

    return {
      currentUserNameFirst,
      currentUserNameLast,
      currentUserOrg,
      currentUserRole,
      errorMessage,
      processLogout,
    };
  },
});
</script>
<style scoped>
.navbar {
  position: fixed;    display: flex;
  top: 0;  left: 0;  height: 70px;  width: 100%;  z-index: 1000; /* Ensure navbar is on top of other content */
  margin: 0; padding: 0;
  background-color: #333;  color: white;
  justify-content: space-between;
  align-items: center;
}
.navbar img {
/* .navbar .img-logo { */
  position: fixed;
  top: 5px;  left: 15px;
  width: 60px;  height: auto;
}
.navbar .cl-matchreportslogo {
    position: fixed;
    top: 10px;  left: 85px;
    font-family: Arial, sans-serif;
    font-size: x-large; font-weight: bold;
}
.navbar .cl-userinfo {
    position:fixed;
    top: 43px;  left: 100px;
    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
    color: #b3e0ff;
}
.navbar .cl-weblinks {
  position: fixed;  
  display: flex; gap: 25px;
  top: 40px;  left: 37%;
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
    font-style: normal;  font-size: large;  list-style-type: none;
}
.navbar .cl-weblinks li a {
      color: white;
      text-decoration: none;
}
.navbar .cl-weblinks li a:hover {
      text-decoration: underline;
}
.navbar .cl-logoutbutton {
    background-color: #b30086;
    border: none;
    padding: 5px 10px;
    color: #fff;
    border-radius: 5px;
    cursor: pointer;
}
.navbar .cl-logoutbutton :hover {
      background-color: #d43f3f;
}
</style>

  